module.exports = __webpack_public_path__ + "img/banner_online_CN.4348c664.png";